import React from 'react'
import { emptyFieldStyle, NotFilledBadge } from './shared'
import FileUploader from '../../components/FileUploaderPortal/FileUploader'

interface Props {
  label: string
  isEmptyInDrive: boolean
  notFilledLabel: string
  uploaderKey: number
  multiple: boolean
  accept: string
  maxSizeInMB: number
  formats: string[]
  onFilesAdded: (files: File[]) => void
  onDelete: () => void
  onValidationError: (msg: string) => void
  error?: string
  onClearError?: () => void
  hint?: string
}

export default function DocumentFileFormGroup({
  label,
  isEmptyInDrive,
  notFilledLabel,
  uploaderKey,
  multiple,
  accept,
  maxSizeInMB,
  formats,
  onFilesAdded,
  onDelete,
  onValidationError,
  error,
  onClearError,
  hint,
}: Props) {
  return (
    <div className="form-group" style={isEmptyInDrive ? emptyFieldStyle : {}}>
      <label>
        {label}
        {isEmptyInDrive && <NotFilledBadge label={notFilledLabel} />}
      </label>
      <FileUploader
        key={uploaderKey}
        multiple={multiple}
        accept={accept}
        maxSizeInMB={maxSizeInMB}
        formats={formats}
        onFilesAdded={(files) => {
          onFilesAdded(files)
          onClearError?.()
        }}
        onDelete={() => {
          onDelete()
          onClearError?.()
        }}
        onValidationError={onValidationError}
      />
      {error && (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {error}
        </div>
      )}
      {hint && <small className="text-muted">{hint}</small>}
    </div>
  )
}
